module.exports = __webpack_public_path__ + "img/8.e3adc908.jpg";